// Auto-generated lightweight class for SystemPrompt
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { SystemPromptReadAPI, SystemPromptWriteAPI, SystemPromptReadAPISchema, SystemPromptWriteAPISchema } from '../types/systemprompt';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, IslandHoldsPin, UsesSystemPromptForRequest } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';
import { ModelRequest } from './modelrequest';
import { IslandPin } from '../../rflp/api/islandpin';



export interface SystemPrompt extends Partial<SystemPromptReadAPI> {}
export class SystemPrompt extends NeoNodeBase<SystemPromptReadAPI, SystemPromptWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "SystemPrompt";
  static readonly readSchema = SystemPromptReadAPISchema;
  static readonly writeSchema = SystemPromptWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    used_by_requests: { target: "ModelRequest", cardinality: "many", isParent: false, relClass: "UsesSystemPromptForRequest", direction: "in" },
    island_pins: { target: "IslandPin", cardinality: "many", isParent: false, relClass: "IslandHoldsPin", direction: "out" },
  };

  protected get modelName(): string {
    return 'SystemPrompt';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return SystemPrompt.label;
  }


  constructor(data: Partial<SystemPromptWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: SystemPromptReadAPI, loadContext?: Record<string, any>): SystemPrompt {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, used_by_requests, island_pins, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = SystemPromptReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope, used_by_requests: used_by_requests, island_pins: island_pins };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return SystemPrompt.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'used_by_requests', 'ModelRequest', ModelRegistry);
    loadManyRelationship(processed, 'island_pins', 'IslandPin', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new SystemPrompt(processed as any);

    return instance;
  }


  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'used_by_requests' - Python ORM style (cached)
  get used_by_requests(): RelationshipManager<this, ModelRequest> {
    return this.getOrCreateRelationshipManager('used_by_requests', () => {
      return new RelationshipManager(this, 'used_by_requests', 'many', UsesSystemPromptForRequest as typeof Relationship);
    });
  }

  // Relationship manager for 'island_pins' - Python ORM style (cached)
  get island_pins(): RelationshipManager<this, IslandPin> {
    return this.getOrCreateRelationshipManager('island_pins', () => {
      return new RelationshipManager(this, 'island_pins', 'many', IslandHoldsPin as typeof Relationship);
    });
  }

}
